/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The LoginUserConfig model module.
* @module model/LoginUserConfig
* @version 2020-12-7
*/
export default class LoginUserConfig {
    /**
    * Constructs a new <code>LoginUserConfig</code>.
    * ログインユーザーに関する設定
    * @alias module:model/LoginUserConfig
    * @class
    * @param useManualSupplyRegistration {Boolean} 給油情報を手動登録するかどうか
    */

    constructor(useManualSupplyRegistration) {
        
        
        this['useManualSupplyRegistration'] = useManualSupplyRegistration;
        
    }

    /**
    * Constructs a <code>LoginUserConfig</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/LoginUserConfig} obj Optional instance to populate.
    * @return {module:model/LoginUserConfig} The populated <code>LoginUserConfig</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LoginUserConfig();
                        
            
            if (data.hasOwnProperty('useManualSupplyRegistration')) {
                obj['useManualSupplyRegistration'] = ApiClient.convertToType(data['useManualSupplyRegistration'], 'Boolean');
            }
        }
        return obj;
    }

    /**
    * 給油情報を手動登録するかどうか
    * @member {Boolean} useManualSupplyRegistration
    */
    'useManualSupplyRegistration' = undefined;




}
